import _ from 'lodash';

import CustomerLookupConfig from 'models/customer_lookup_config';
import Err from 'models/err';
import LookupApiConfig, { BasicAuthCredentials } from 'models/lookup_api_config';
import createBlankError from 'scripts/domain/factories/error/create_blank_error';

export default class SaveLookupApiConfig {
  constructor(context) {
    this.context = context;
  }

  run({ credentials, headers, name, signingKey, url, disabled, autoLinkFields, overwritingEnabled }) {
    let trimmedAttrs = {
      credentials: trimAttrsObject(credentials),
      headers: trimObjectList(headers),
      name: _.trim(name),
      signingKey: _.isUndefined(signingKey) ? undefined : _.trim(signingKey),
      url: _.trim(url),
    };

    let validationErrors = LookupApiConfig.getValidationErrors(trimmedAttrs, 'adapterConfiguration.');
    validationErrors = validationErrors.concat(validateHeadersList(trimmedAttrs.headers));

    if (validationErrors.length > 0) {
      this.context.stores.lookupApiConfig.setErrors(validationErrors);
      return;
    }

    let headersToSave = _.reduce(
      trimmedAttrs.headers,
      (accumulator, kvTuple) => {
        return _.assign(accumulator, { [kvTuple.headerKey]: kvTuple.headerValue });
      },
      {}
    );

    let basicAuthCredentials = _.isEmpty(trimmedAttrs.credentials)
      ? undefined
      : BasicAuthCredentials.create(trimmedAttrs.credentials);

    let newLookupApiConfig = LookupApiConfig.create({
      credentials: basicAuthCredentials,
      headers: headersToSave,
      name: trimmedAttrs.name,
      signingKey: trimmedAttrs.signingKey,
      url: trimmedAttrs.url,
    });

    let newCustomerLookupConfig = CustomerLookupConfig.create({
      adapterType: 'LOOKUP_API',
      adapterConfiguration: newLookupApiConfig,
      autoLinkFields,
      disabled,
      overwritingEnabled,
    });

    this.context.gateways.customerLookupConfiguration.replace(newCustomerLookupConfig.toJs());
    this.context.stores.lookupApiConfig.setPending(newCustomerLookupConfig);
  }
}

function trimObjectList(objectList) {
  return _.map(objectList, function(objectToTrim) {
    return trimAttrsObject(objectToTrim);
  });
}

function trimAttrsObject(attrs) {
  return _.reduce(
    attrs,
    (accumulator, attrValue, attrKey) => {
      return _.assign(accumulator, { [attrKey]: typeof attrValue === 'string' ? attrValue.trim() : attrValue });
    },
    {}
  );
}

function validateHeadersList(headersAsList) {
  let errors = [];
  let headersThusFar = {};

  _.each(headersAsList, function(keyValueTuple, index) {
    if (headersThusFar.hasOwnProperty(keyValueTuple.headerKey)) {
      errors.push(
        new Err({
          code: Err.Code.TAKEN,
          attr: `adapterConfiguration.headers.${index}.key`,
          detail: 'duplicate keys are not allowed\n',
        })
      );
    } else {
      headersThusFar[keyValueTuple.headerKey] = true;
    }

    if (_.isEmpty(_.trim(keyValueTuple.headerKey))) {
      errors.push(createBlankError(`adapterConfiguration.headers.${index}.key`, 'key'));
    }

    // ignore header values which are being deleted (null) or being left unchanged (undefined)
    if (!_.isNil(keyValueTuple.headerValue) && _.isEmpty(_.trim(keyValueTuple.headerValue))) {
      errors.push(createBlankError(`adapterConfiguration.headers.${index}.value`, 'value'));
    }
  });

  return errors;
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/integrations/save_lookup_api_config.js